import { useTranslation } from "react-i18next";
import styles from "./FeedbackWithReply.module.scss";

interface FeedbackItem {
  rating: number;
  feedbackText: string;
  name: string;
  date: string;
  replyText: string;
}

const FeedbackWithReply = () => {
  const { t } = useTranslation("common");

  // 🆕 Безпечне отримання масиву з перевіркою
  const feedbackDataRaw = t("reviews.items", {
    returnObjects: true,
    defaultValue: [],
  });

  // 🆕 Перевірка що це масив
  const feedbackData: FeedbackItem[] = Array.isArray(feedbackDataRaw)
    ? feedbackDataRaw
    : [];

  // 🆕 Якщо немає відгуків - показуємо повідомлення
  if (feedbackData.length === 0) {
    return (
      <div className="container">
        <div className="sectionContainer sectionContainerWhite">
          <p>Noch keine Bewertungen vorhanden.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="sectionContainer sectionContainerWhite">
        {feedbackData.map((feedback, index) => (
          <div key={index} className={styles.feedback}>
            <div className={styles.rating}>
              {[1, 2, 3, 4, 5].map((star) => (
                <img
                  key={star}
                  src={
                    star <= feedback.rating
                      ? "/images/star-full.svg"
                      : "/images/star-empty.svg"
                  }
                  alt={t("feedback.starAlt", { number: star })}
                  className={styles.star}
                />
              ))}
              <p className={styles.date}>{feedback.date}</p>
            </div>
            <p className={styles.feedbackText}>{feedback.feedbackText}</p>
            <p className={styles.name}>{feedback.name}</p>
            <div className={styles.replyContainer}>
              <div className={styles.replyHeader}>
                <span className={styles.replyText}>
                  {t("reviews.replyFrom")}
                </span>
              </div>
              <div className={styles.reply}>
                <p>{feedback.replyText}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeedbackWithReply;
